import { getPageActivity } from './pageActivity';
import { TRequestDiagnostics } from './types';
import { IApplicationContext } from '../../../types/applicationContext';
import { TAppState } from '../../../types/appState';

/**
 * Собирает условия, в которых выполняется запрос к публичной ручке чатов
 */
export function getRequestDiagnostics(state: TAppState, context: IApplicationContext): TRequestDiagnostics {
  const eventChannel = context.custom.socket?.eventChannel;
  const hasDocument = typeof document !== 'undefined';
  const hasNavigator = typeof navigator !== 'undefined';

  return {
    userSessionId: context.custom.userSessionId || null,
    /** Возраст снимка авторизации: сколько прошло с серверного рендера страницы */
    snapshotAge: state.renderedAt ? Date.now() - state.renderedAt : null,
    isAuthenticated: state.user.isAuthenticated,
    userId: state.user.userId,
    /** Статус сокета в сторе может расходиться с фактическим состоянием канала, поэтому пишем оба */
    socketStatus: state.socketStatus,
    socketHasInstance: eventChannel ? eventChannel.hasInstance() : null,
    socketClosed: eventChannel ? eventChannel.isChannelClosed() : null,
    internetStatus: state.internetStatus,
    isOnline: hasNavigator ? navigator.onLine : null,
    hasFocus: hasDocument ? document.hasFocus() : null,
    visibilityState: hasDocument ? document.visibilityState : null,
    hostType: state.hostType,
    currentRoute: state.chatList.currentRoute,
    currentOpenedChatId: state.chatWindow.currentOpenedChatId || null,
    ...getPageActivity(),
  };
}
